import Slider from "react-slick"
import { motion } from "framer-motion"
import { sliderSettings } from "components/atoms/SliderSettings"
import H2 from "components/atoms/H2"
import useTranslations from "hooks/useTranslations"
import Button from "components/buttons/Button"
import { StaticImage } from "gatsby-plugin-image"
import { useContext } from "react"
import cc from "classcat"
import { LocaleContext } from "../../contexts"

function countDefinedStrings(list) {
  const definedStrings = list.filter(
    (element) => typeof element !== "undefined",
  )
  return definedStrings.length
}

const ListItem = ({ Image, title, text }) => (
  <div className="mb-8" key={title}>
    <div className="mb-6 flex justify-center">
      <Image />
    </div>
    <div className="mt-2 block">
      <p className="m-0 font-display text-2xl font-semibold text-zinc-900">
        {title}
      </p>
      <p className="m-0 mt-3 text-lg text-zinc-800">{text}</p>
    </div>
  </div>
)

const Image1 = () => (
  <StaticImage
    src="../../images/howitworks/AdobeStock_385495884.jpeg"
    alt=""
    objectFit="cover"
    className="isolate h-44 w-44 overflow-hidden rounded-full"
    width={200}
  />
)

const Image2 = () => (
  <StaticImage
    src="../../images/howitworks/AdobeStock_425568426.jpeg"
    alt=""
    objectFit="cover"
    className="isolate h-44 w-44 overflow-hidden rounded-full"
    width={200}
  />
)

const Image3fi = () => (
  <StaticImage
    src="../../images/howitworks/hand-phone-answer-fi.jpg"
    alt=""
    objectFit="cover"
    className="isolate h-44 w-44 overflow-hidden rounded-full"
    width={200}
  />
)

const Image3se = () => (
  <StaticImage
    src="../../images/howitworks/hand-phone-answer-se.jpg"
    alt=""
    objectFit="cover"
    className="isolate h-44 w-44 overflow-hidden rounded-full"
    width={200}
  />
)

export const HowItWorks = ({
  translations,
  titleAlign = "center",
  images = {},
  theme = "green",
}) => {
  const { appLink } = useTranslations()
  const { locale } = useContext(LocaleContext)

  const list = [
    {
      Image: images.Image1 || Image1,
      title: translations.feature1Title,
      text: translations.feature1Text,
    },
    {
      Image: images.Image2 || Image2,
      title: translations.feature2Title,
      text: translations.feature2Text,
    },
    {
      Image:
        images.Image3 ||
        (locale === "sv-fi" || locale === "sv-se" ? Image3fi : Image3se),
      title: translations.feature3Title,
      text: translations.feature3Text,
    },
  ]
  const listLength = countDefinedStrings([
    translations.feature1Title,
    translations.feature2Title,
    translations.feature3Title,
    translations.feature4Title,
  ])

  if (listLength === 4) {
    list.push({
      Image: images.Image4 || Image2,
      title: translations.feature4Title,
      text: translations.feature4Text,
    })
  }
  return (
    <div
      className={cc([
        "relative py-16 lg:py-24",
        {
          "bg-kkm-green": theme === "green",
          "bg-kkm-yellow": theme === "yellow",
        },
      ])}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <H2 theme="dark" textAlign={titleAlign}>
            {translations.title}
          </H2>
        </div>

        <div className="mt-12">
          <div
            className={cc([
              "hidden gap-16 lg:grid",
              listLength === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3",
            ])}
          >
            {list.map(({ Image, title, text }) => (
              <ListItem Image={Image} title={title} text={text} key={title} />
            ))}
          </div>
          <div className="block lg:hidden ">
            <div className="mr-4">
              <Slider slidesToShow={1} {...sliderSettings("white-on-green")}>
                {list.map(({ Image, title, text }) => (
                  <ListItem Image={Image} title={title} text={text} />
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <div className="mt-12 flex justify-center lg:mt-4">
          <Button
            label={translations.buttonLogin}
            link={appLink}
            bgStyle="light"
            size="xl"
            outbound
          />
        </div>
      </div>
    </div>
  )
}

const HowItWorksTranslations = () => {
  const {
    howItWorksTitle,
    howItWorks2Feature1Title,
    howItWorks2Feature1Text,
    howItWorks2Feature2Title,
    howItWorks2Feature2Text,
    howItWorks2Feature3Title,
    howItWorks2Feature3Text,
    buttonLogin,
  } = useTranslations()
  return (
    <HowItWorks
      translations={{
        title: howItWorksTitle,
        feature1Title: howItWorks2Feature1Title,
        feature1Text: howItWorks2Feature1Text,
        feature2Title: howItWorks2Feature2Title,
        feature2Text: howItWorks2Feature2Text,
        feature3Title: howItWorks2Feature3Title,
        feature3Text: howItWorks2Feature3Text,
        buttonLogin,
      }}
    />
  )
}

export default HowItWorksTranslations
